import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Intake, SurveyModel } from '../models';
import { Api, Session } from '../services/index';

declare function redirectToPhs(isTest: boolean): any;

@Component({
  selector: 'app-survey',
  templateUrl: './exam-survey.html'
})
export class ExamSurveyComponent implements OnInit {

  @ViewChild('experienceRatingInput') experienceRatingInput: any;

  alternativeChoice: string;
  consentChecked: boolean;
  experienceRating: number = 0;
  patientSurvey: SurveyModel;
  providerRating: number = 0;
  submitted: boolean;

  constructor(private api: Api, 
              private route: ActivatedRoute,
              private router: Router,
              public session: Session) { 
    this.patientSurvey = new SurveyModel();

  }



  ngOnInit() {
    console.log('ionViewDidLoad ExamSurveyPage');
    this.session.showMenu = false;
    this.submitted = false;

    this.loadData();
  }

  getIntakeLOB(){
    return this.session.intakeLob;
  }

  loadData() {
  
    this.ratingTapped('experienceRating', 5);
  }

  ratingTapped(subject, value) {
    try{
      this[subject] = value;

      let ratingContainer = this[(subject + 'Input')].nativeElement;
      let starElements = ratingContainer.getElementsByTagName('img');
      for (var i = 0; i < starElements.length; ++i) {
        starElements[i].src = "assets/images/" + (i < value ? "star-full.svg" : "star-empty.svg");
      }
      if (subject == 'experienceRating') {
        this.experienceRating = value;
      }
    }catch(err){
      let phsSurveyLocation = "https://phs.qualtrics.com/jfe/form/SV_esRP30ovjyqyTdP";
      let newWindow = window.open("about:blank", "_blank");
      newWindow.opener = null;
      newWindow.location.href = phsSurveyLocation;
     
      redirectToPhs(false);
    }
 
   
  }
  submitSurvey() {
    let phsSurveyLocation = "https://phs.qualtrics.com/jfe/form/SV_esRP30ovjyqyTdP";
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = phsSurveyLocation;
   
    redirectToPhs(false);

   
  
  }
  submitTapped() {
    try{
      this.session.showMenu = true;
      if(this.experienceRating){
        this.patientSurvey.ExperienceRating = (this.experienceRating) ? this.experienceRating : 5;
      }else{
        this.patientSurvey.ExperienceRating = 5;
      }
      this.patientSurvey.ProviderRating =  5;
      this.patientSurvey.SurveyType =  'other';
      this.patientSurvey.Comment =  'PHS';
      this.patientSurvey.AllowedtoShare =  false;
      if (this.session.serverIntake.intakeId) {
        this.patientSurvey.IntakeId = Number(this.session.serverIntake.intakeId);
        this.api.updatePatientSurvey(this.patientSurvey).subscribe(data => {
          let phsSurveyLocation = "https://phs.qualtrics.com/jfe/form/SV_esRP30ovjyqyTdP";
          let newWindow = window.open("about:blank", "_blank");
          newWindow.opener = null;
          newWindow.location.href = phsSurveyLocation;
         
          redirectToPhs(false);
        }, err => {
          let phsSurveyLocation = "https://phs.qualtrics.com/jfe/form/SV_esRP30ovjyqyTdP";
          let newWindow = window.open("about:blank", "_blank");
          newWindow.opener = null;
          newWindow.location.href = phsSurveyLocation;
         
          redirectToPhs(false);
        });
      }else{
        let phsSurveyLocation = "https://phs.qualtrics.com/jfe/form/SV_esRP30ovjyqyTdP";
        let newWindow = window.open("about:blank", "_blank");
        newWindow.opener = null;
        newWindow.location.href = phsSurveyLocation;
        redirectToPhs(false);
      }
    }catch(error){
      let phsSurveyLocation = "https://phs.qualtrics.com/jfe/form/SV_esRP30ovjyqyTdP";
      let newWindow = window.open("about:blank", "_blank");
      newWindow.opener = null;
      newWindow.location.href = phsSurveyLocation;
      redirectToPhs(false);
    }

   
  
  }
}
